import { Box } from "@mui/material"
import Lottie from "lottie-react";

import comingSoon from "@arelia-assets/lottie-animations/coming-soon.json"
import manPlayingAGuitarAnimation from "@arelia-assets/lottie-animations/man-playing-a-guitar.json"

export function ComingSoonScreen() {
  const style = {
    height: 300,
  };

  return (
    <Box width="100%" height="100%" display="flex" justifyContent="center" alignItems="center" flexDirection="column">
      <Lottie
        animationData={manPlayingAGuitarAnimation}
        style={style}
      />
      <Lottie
        animationData={comingSoon}
        style={{
          ...style,
          marginTop: -150
        }}
      />
    </Box>
  );
}